import TreeViewContainer from "../../Componant/BonusUI/TreeView";

const TreeView = () => {
  return <div className="page-body">
    <TreeViewContainer />
  </div>;
};

export default TreeView;
